<template>
<div class="order-wrapper">
  <portal target-el="#filter">
    <FilterHeader :paidto="paidto"/>
  </portal>
  <div class="table-title row no-margin table-title-content">
    <div class="col-lg-4 col-md-4 content-section-left">
      <div class="content-section">
        <div class="content-list">
          <span class="content-list-title bold primary-text">
            {{transporter.name}}
          </span>
        </div>

        <div class="content-list">
          <span class="content-list-title">
            <div>{{transporter.address}}</div>
            <div>
              {{transporter.city}}
              {{transporter.state}} - {{transporter.pincode}}
            </div>
          </span>
        </div>
        <!--
        <div class="content-list">
          <span class="content-list-title bold">GST IN : </span>
          <span class="content-list-title">AA330917005320N  </span>
        </div>
        <div class="content-list">
          <span class="content-list-title bold">PAN :  </span>
          <span class="content-list-title">PAN330917005320N </span>
        </div> -->
      </div>
    </div>

    <div class="col-lg-4 col-md-4 content-section-left">
      <div class="content-section">
        <div class="content-list">
          <span class="content-list-title bold primary-text">
            {{client.name}}
          </span>
        </div>

        <div class="content-list">
          <span class="content-list-title">
            <div>{{client.address}}</div>
            <div>
              {{client.city}}
              {{client.state}} - {{client.pincode}}
            </div>
          </span>
        </div>
        <!--
        <div class="content-list">
          <span class="content-list-title bold">GST IN : </span>
          <span class="content-list-title">AA330917005320N  </span>
        </div> -->
      </div>
    </div>

    <div class="col-lg-4 col-md-6 content-section-right">
      <div class="content-section">
        <div class="content-list">
          <span class="content-list-title bold">Date: </span>
          <span class="content-list-title">{{date | moment("DD MMM YYYY") }}</span>
        </div>

        <div class="content-list">
          <span class="content-list-title bold">Tax payable on reverse charge : </span>
          <span class="content-list-title">{{reversecharge}}</span>
        </div>

        <div class="content-list">
          <span class="content-list-title bold">Service Description : </span>
          <span class="content-list-title">Movement of goods by Road </span>
        </div>
        <!--
        <div class="content-list">
          <span class="content-list-title bold">HSN/SAC : </span>
          <span class="content-list-title"> -- </span>
        </div>

        <div class="content-list">
          <div class="action">
            <Comments />
          </div>
        </div> -->

      </div>
    </div>

  </div>

  <div class="order-content">
    <div class="table-title">
    </div>
    <div class="order-list-wrapper">
      <div class="table-row-lite note-table">
        <div class="table-td-lite descrow">
          Credit Note Amount for Invoice #{{invoiceNo}}
        </div>
        <div class="table-td-lite w200 invoice-note-right">
          {{Number(noteValue).toFixed(2)}}
        </div>
      </div>
      <Footer @paidtochanged="paidtochanged"/>
    </div>
  </div>
</div>
</template>

<script>
import Header from '../../payment/Invoice/Header';
import Row from '../../payment/Invoice/Row';
import Footer from '../../payment/Invoice/Footer';
import DetailTable from '../../payment/Invoice/DetailTable';
import FilterHeader from '../../payment/Invoice/FilterHeader';
import Comments from '../../common/comments/comments';

export default {
  components: {
    Header,
    Row,
    Footer,
    FilterHeader,
    DetailTable,
    Comments,
  },

  data() {
    const payment = this.$store.payments.selected[0];
    return {
      comment: false,
      paidto: payment.paid_to,
      reversecharge: payment.paid_to === '2' ? 'No' : 'Yes',
    };
  },
  computed: {
    client() {
      return this.$store.state.app.data.clients[0];
    },
    transporter() {
      return this.$store.state.app.data.transporter;
    },
    date() {
      return this.$store.showInvoice ? this.$store.invoice.created_at :
        (new Date()).toISOString();
    },
    noteValue() {
      return this.$store.invoice.revision.value;
    },
    invoiceNo() {
      return this.$store.invoice.invoice_number;
    },
  },
  methods: {
    paidtochanged(paidto) {
      this.paidto = paidto;
      this.reversecharge = paidto === '2' ? 'No' : 'Yes';
    },
  },
};
</script>
<style lang='scss'>
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.payment-actions {
    width: calc(100% - 1230px);
    text-align: right;
}
.order-content {
    padding-bottom: 30px;
    background: #fff;
    padding: 20px;
    box-shadow: 0 2px 4px 0 #ECECEC;
    height: 100vh;
    .table-row {
        padding-left: 15px;
    }
}
.table-title {
    &-content {
        background: #F9FAFA;
        padding: 0;
        border: 1px solid #EFEFEF;
    }
    .float-right {
        text-align: right;
    }
    h2 {
        font-family:$fontSemibold;
        font-size: 1.6rem;
        letter-spacing: 1.33px;
        padding: 0 0 15px;
        margin: 0;
    }
}
.content-section {
    &-left {
        float: left;
        display: inline-block;
        border-left: 0.5px solid #CECECE;
        padding: 0 16px;
        margin: 10px 0;
        &:first-child {
            border-left: 0.5px solid transparent;
        }
    }
    &-right {
        float: right;
        display: inline-block;
        text-align: right;
        background: #fff;
        padding: 10px 15px;
    }

}
.content-list {
    line-height: 22px;
    .primary-text {
        font-size: 1.4rem;
    }
    .bold {
        font-family:$fontSemibold;
    }
    &-title {
        font-size: 1.2rem;
        color: #404040;
    }

}
.invoice-note-right {
    width: calc(100% - 150px);
    text-align: right;
    padding-right: 25px !important;
}
.popover-primary {
    textarea {
        border: 1px solid #DEE5E6;
        width: 100%;
        border-radius: 2px;
        padding: 10px;
        margin: 20px 0;
        outline: none;
    }
}
.note-table {
  border: 1px solid #EFEFEF;
  background-color: #F9FAFA;
  margin-top: 20px;
}
.descrow {
  width: 600px;
  color: #404040;
  font-family:$fontSemibold;
  font-size: 14px;
  line-height: 17px;
}
</style>
